import React from 'react';
import { translations } from '../data/translations';
import { MapPin, Phone, Clock, Mail, Facebook, Instagram } from 'lucide-react';
import { Button } from "./ui/button";
import { PrivacyDialog } from './PrivacyDialog';

export const ContactSection = ({ lang }) => {
  const t = translations[lang].contact;
  const f = translations[lang].footer;

  return (
    <footer id="contact" className="bg-black text-white pt-24 pb-8 border-t border-zinc-900">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          
          {/* Brand & Socials */}
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              <div className="h-12 w-12 flex items-center justify-center overflow-hidden rounded-full bg-white p-1">
                 <img src="https://customer-assets.emergentagent.com/job_7fc4b9e7-8343-429e-97eb-b7f84a7435e7/artifacts/vlu7m02g_buffalo%20logo.svg" alt="Buffalo Logo" className="w-full h-full object-contain" />
              </div>
              <div className="flex flex-col">
                <span className="text-2xl font-bold tracking-tighter">BUFFALO</span>
                <span className="text-xs text-red-500 font-bold tracking-[0.2em] -mt-1">GRILL HOUSE</span>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed max-w-xs">
              Klaukkalan paras grilli. Tule ja maista aitoja makuja.
            </p>
            <div className="flex gap-4 pt-2">
              <a href="#" className="h-10 w-10 bg-zinc-900 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="h-10 w-10 bg-zinc-900 rounded-full flex items-center justify-center hover:bg-red-600 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-6">
            <h3 className="text-xl font-bold border-l-4 border-red-600 pl-4">{t.title}</h3>
            <ul className="space-y-4 text-gray-300">
              <li className="flex items-start gap-4">
                <MapPin className="w-5 h-5 text-red-500 mt-1 shrink-0" />
                <span>Kuonomäentie 1, <br/>01800 Nurmijärvi</span>
              </li>
              <li className="flex items-center gap-4">
                <Phone className="w-5 h-5 text-red-500 shrink-0" />
                <a href="tel:098797826" className="hover:text-red-500 transition-colors">09 8797826</a>
              </li>
              <li className="flex items-center gap-4">
                <Clock className="w-5 h-5 text-red-500 shrink-0" />
                <div className="text-sm">
                  <p>{t.hours_mon_thu}</p>
                  <p>{t.hours_fri}</p>
                  <p>{t.hours_sat}</p>
                  <p>{t.hours_sun}</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Map */}
          <div className="h-64 rounded-lg overflow-hidden border border-zinc-800 bg-zinc-900">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1964.739777505187!2d24.7478!3d60.379!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x468df6d000000001%3A0x0!2zNjDCsDIyJzQ0LjQiTiAyNMKwNDQnNTIuMSJF!5e0!3m2!1sen!2sfi!4v1620000000000!5m2!1sen!2sfi"
              width="100%" 
              height="100%" 
              style={{ border: 0 }} 
              allowFullScreen="" 
              loading="lazy"
              title="Restaurant Location"
            ></iframe>
          </div>
        </div>

        <div className="border-t border-zinc-900 pt-8 text-center text-gray-500 text-sm flex flex-col items-center gap-2">
          <p>&copy; {new Date().getFullYear()} Buffalo Grill House. {f.rights}</p>
          <PrivacyDialog lang={lang} />
        </div>
      </div>
    </footer>
  );
};
